<div class="w-full p-4 rounded-[8px] mt-5"
    [ngClass]="[!location ? 'animate-pulse' : '', location?.is_active ? 'bg-secondary' : 'bg-neutral-500']">
    <p class="text-[#FFFFFF] text-lg">{{ 'shared.location' | transloco }} {{displayNumber || '...'}}</p>
    <p class="text-warning" *ngIf="!location?.is_active && location">{{ 'locations.inactive_warning' | transloco}}</p>
</div>

<div class="w-full flex flex-col gap-5 mt-5" *ngIf="location">
    <!-- First Row -->
    <div class="flex flex-wrap gap-5 min-h-[244px] mobile:flex-col mobile:gap-2">
        <!-- Left Box -->
        <div
            class="desktop:flex-[1] mobile:w-full mobile:min-h-[244px] p-0 rounded-[14px] bg-[#FFFFFF] border-[1px] border-border min-w-[300px] flex flex-wrap gap-2 mobile:flex-col">
            <!-- Left text -->
            <div class="desktop:flex-[1] min-w-[200px] flex flex-col gap-2 m-5">
                <div class="flex flex-col gap-1">
                    <p class="text-neutral-1200 text-sm">{{ 'locations.street_and_number' | transloco }}</p>
                    <p class="text-xl text-black font-semibold">{{location.street}} {{location.number}}</p>
                </div>
                <div class="flex flex-col gap-1">
                    <p class="text-neutral-1200 text-sm">{{ 'locations.postal_and_city' | transloco }}</p>
                    <p class="text-xl text-black font-semibold">{{location.postal_code}} {{location.city}}</p>
                </div>
                <div class="flex flex-col gap-1">
                    <p class="text-neutral-1200 text-sm">{{ 'shared.labels.province' | transloco }}</p>
                    <p class="text-xl text-black font-semibold">{{location.province}}</p>
                </div>
                <div class="w-[150px] h-[45px]">
                    <app-custom-button buttonText="{{ 'locations.edit_data' | transloco }}" backgroundColor="bg-primary"
                        textColor="text-white" borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                        (buttonClick)="editLocation()"></app-custom-button>
                </div>
            </div>
            <!-- Right map text -->
            <div class="desktop:flex-[1] min-w-[200px] m-5">
                <div class="w-full h-[240px] mobile:h-[400px]">
                    <app-interactive-map *ngIf="location.latitude && location.longitude" [latitude]="location.latitude"
                        [longitude]="location.longitude"></app-interactive-map>
                    <div *ngIf="!location.latitude || !location.longitude"
                        class="w-full h-[240px] bg-neutral-300 rounded mobile:h-[400px] animate-pulse"></div>
                </div>
            </div>
        </div>
        <!-- Right Box -->
        <div
            class="desktop:flex-[1] mobile:w-full mobile:min-h-[244px] p-0 rounded-[14px] bg-[#FFFFFF] border-[1px] border-border min-w-[300px]">
            <!-- Header text -->
            <div class="flex">
                <div class="flex flex-col gap-4 min-h-[60px] justify-between">
                    <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                        'locations.consumption_last_12_months' | transloco }}
                    </p>
                    <div class="h-[2px] w-full bg-primary"></div>
                </div>
                <div class="min-h-[60px] flex flex-grow items-end justify-start">
                    <div class="h-[2px] w-full bg-border"></div>
                </div>
            </div>

            <!-- Content -->
            <div class="m-4 flex flex-col gap-2 w-full">
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.electricity' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{
                            locationConsumption?.electricity_consumption !==
                            null &&
                            locationConsumption?.electricity_consumption !== undefined
                            ? (locationConsumption?.electricity_consumption | number:'1.2-2')
                            : notAvailable }} {{ 'shared.kwh'
                            | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{
                            locationConsumption?.electricity_cost !== null &&
                            locationConsumption?.electricity_cost !== undefined
                            ? (locationConsumption?.electricity_cost | number:'1.2-2')
                            : notAvailable }} Є</p>
                    </div>

                    <div class="flex-[1] min-w-[200px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.gas' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{
                            locationConsumption?.gas_consumption
                            !==
                            null &&
                            locationConsumption?.gas_consumption !== undefined
                            ? (locationConsumption?.gas_consumption | number:'1.2-2')
                            : notAvailable }} smc</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{
                            locationConsumption?.gas_cost !==
                            null &&
                            locationConsumption?.gas_cost
                            !== undefined
                            ? (locationConsumption?.gas_cost | number:'1.2-2')
                            : notAvailable }} Є</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- Second Row -->
    <div class="flex flex-wrap gap-5 min-h-[282px] mobile:flex-col mobile:gap-2">
        <!-- Left Box -->
        <div
            class="desktop:flex-[1] mobile:w-full mobile:min-h-[282px] p-0 rounded-[14px] bg-[#FFFFFF] border-[1px] border-border min-w-[300px]">
            <!-- Header text -->
            <div class="flex">
                <div class="flex flex-col gap-4 min-h-[60px] justify-between">
                    <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'shared.electricity' |
                        transloco
                        }}
                    </p>
                    <div class="h-[2px] w-full bg-primary"></div>
                </div>
                <div class="min-h-[60px] flex flex-grow items-end justify-start">
                    <div class="h-[2px] w-full bg-border"></div>
                </div>
            </div>


            <!-- Content -->
            <div class="m-4 flex flex-col gap-2 w-full" *ngFor="let pod of selectedPods">
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.electricity.supplier' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{pod?.supplier }}</p>
                    </div>
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.electricity.vat' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{pod?.vat }}</p>
                    </div>
                </div>
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.electricity.pod_id' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{pod?.pod_id }}</p>
                    </div>
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.electricity.start_of_supply' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{
                            pod?.start_of_supply }}
                        </p>
                    </div>
                </div>
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'locations.available_capacity' | transloco }}
                        </p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{
                            pod?.available_capacity }} kW</p>
                    </div>

                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.electricity.end_of_supply' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{
                            pod?.end_of_supply }}</p>
                    </div>
                </div>
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.electricity.tension' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{pod?.tension }}</p>
                    </div>
                </div>
            </div>
            <app-empty-pod-data *ngIf="selectedPods.length == 0" [vat]="getVatValue()"></app-empty-pod-data>
        </div>
        <!-- Right Box -->
        <div
            class="desktop:flex-[1] mobile:w-full mobile:min-h-[282px] p-0 rounded-[14px] bg-[#FFFFFF] border-[1px] border-border min-w-[300px]">
            <!-- Header text -->
            <div class="flex">
                <div class="flex flex-col gap-4 min-h-[60px] justify-between">
                    <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'shared.gas' | transloco }}
                    </p>
                    <div class="h-[2px] w-full bg-primary"></div>
                </div>
                <div class="min-h-[60px] flex flex-grow items-end justify-start">
                    <div class="h-[2px] w-full bg-border"></div>
                </div>
            </div>

            <!-- Content -->
            <div class="m-4 flex flex-col gap-2 w-full" *ngFor="let pdr of selectedPdrs">
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.gas.supplier' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{pdr?.supplier }}</p>
                    </div>
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.gas.vat' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{pdr?.vat }}</p>
                    </div>
                </div>
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.gas.pdr_id' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">{{pdr?.pdr_id }}</p>
                    </div>
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.gas.start_of_supply' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{
                            pdr?.start_of_supply }}</p>
                    </div>
                </div>
                <div class="flex flex-wrap gap-5">
                    <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
                        <p class="text-neutral-1200">{{ 'shared.labels.gas.end_of_supply' | transloco }}</p>
                        <p class="text-black font-semibold text-xl mobile:text-lg">
                            {{
                            pdr?.end_of_supply }}</p>
                    </div>
                </div>
            </div>
            <app-empty-pdr-data *ngIf="selectedPdrs.length == 0" [vat]="getVatValue()"></app-empty-pdr-data>
        </div>
    </div>
</div>